import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { apiRequest } from "../../utils/api";
import 'bulma/css/bulma.min.css';

export default function Login() {
  const [cred, setCred] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await apiRequest('/auth/login', {
        method: 'POST',
        body: JSON.stringify({
          email: cred.email,
          password: cred.password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error en el login');
        return;
      }

      localStorage.setItem('token', data.token);
      if (data.refreshToken) {
        localStorage.setItem('refreshToken', data.refreshToken);
      }
      localStorage.setItem('user', JSON.stringify(data.user));

      login(data.user, data.token, data.refreshToken);
      navigate("/");
      
    } catch (error) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="columns is-gapless is-marginless is-fullheight">
      <div className="column is-hidden-mobile is-half">
        <figure className="image is-fullheight">
          <img 
            src="/calculadora.jpg" 
            alt="Calculadora" 
            style={{ height: '100vh', width: '100%', objectFit: 'cover' }} 
          />
        </figure>
      </div>
      
      <div className="column is-half" style={{ backgroundColor: '#2D2749' }}>
        <div className="hero is-fullheight">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-centered">
                <div className="column is-8-tablet is-8-desktop is-6-widescreen">
                  <div className="has-text-centered mb-6">
                    <figure className="image is-128x128 is-inline-block mb-5">
                      <img src="/logo.png" alt="Logo Nigma" />
                    </figure>
                    <h1 className="title is-2 has-text-white has-text-weight-bold" 
                        style={{ letterSpacing: '0.2em' }}>
                      CONEX
                    </h1>
                  </div>
                  
                  <div className="field">
                    <label className="label has-text-white is-small">USUARIO</label>
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        style={{ backgroundColor: '#E4E4E4' }}
                        value={cred.email}
                        onChange={(e) => setCred({ ...cred, email: e.target.value })}
                      />
                    </div>
                  </div>
                  
                  <div className="field">
                    <label className="label has-text-white is-small">CONTRASEÑA</label>
                    <div className="control">
                      <input
                        className="input"
                        type="password"
                        style={{ backgroundColor: '#E4E4E4' }}
                        value={cred.password}
                        onChange={(e) => setCred({ ...cred, password: e.target.value })}
                      />
                    </div>
                  </div>
                  
                  {error && (
                    <div className="notification is-danger">
                      {error}
                    </div>
                  )}
                  
                  <div className="field mt-5">
                    <div className="control">
                      <button
                        className={`button is-fullwidth ${loading ? 'is-loading' : ''}`}
                        style={{ backgroundColor: '#F9B11E', color: 'white' }}
                        onClick={handleLogin}
                        disabled={loading}
                      >
                        {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
